'use client';
import type { ProductIndexData } from '@eliadmin/core/src/api/products/types/product-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../../ui/heading';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Carousel } from '@eliadmin/core/src/components/ui/carousel';
import { ProductCard } from '../product-card';

export function RelatedProducts({
  products,
}: {
  products:
    | ProductIndexData[]
    | null
    | undefined
    | null
    | undefined
    | null
    | undefined
    | null
    | undefined;
}) {
  const { t } = useTranslations();

  return (
    <section
      className={cn(
        'custom-section',
        'ea-section-medium__center',
        'gap-8 pr-0 sm:gap-12 lg:gap-16 lg:pr-4',
      )}
    >
      <Heading
        title={t('text60')}
        className={{ container: 'w-full items-center justify-center text-center' }}
      />
      <div className={cn('custom-container')}>
        <Carousel
          className={{
            main: 'w-full',
            wrapper: 'w-full',
            slide: 'w-full max-w-[290px] sm:max-w-[340px] md:max-w-[370px] lg:max-w-[384px]',
            container: 'w-full gap-4 sm:gap-5 lg:gap-6',
          }}
          slides={
            products?.map((product, index) => (
              <ProductCard key={index} product={product as any} />
            )) ?? []
          }
        />
      </div>
    </section>
  );
}
